import { Component } from '@angular/core';

@Component({
    selector: 'app-side-menu-navigation',
    templateUrl: './side-menu-navigation.component.html'
})
export class SideMenuNavigationComponent {}
